import { Items } from './items';
import { AppMenu } from './app-menu';

export class HeaderData {
  headerBtnMenu: Items[];
  userMenu: Items[];
  appMenu: Items[];
  userMenuLabel: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/header-data.ts